<template>
    <div class="game-header">
       <span >{{'round' | translate}}</span>
        <span class="game-round">{{gameStatus.displayRoundNumber}}</span>
        <span v-if="gameStatus.roundInProgress">{{ 'in_progress' | translate}}</span>
        <span v-if="gameStatus.countdown">{{ 'starts_in' | translate}}</span>
        <span v-if="gameStatus.countdown" class="game-countdown">{{ moment.utc(gameStatus.startingIn*1000).format('m:ss') }}</span>
        <span v-if="isBettingDisabled">{{'games.betting_disabled_short' | translate}}</span>
    </div>
</template>

<script>

    import {GameSvc} from '../../../services/game.service';
    import {translate} from '../../../filters/translate';
    import moment from 'moment';

    export default {
        name: 'GameHeader',
        filters: {
            translate,
        },
        data() {
            return {
                gameStatus:  GameSvc.getGameSvc().gameInfo,
                moment : moment
            }
        },
        computed: {
        isBettingDisabled () {
            return GameSvc.getGameSvc().gameInfo.betsBlocked;
        }
    },
    };

</script>

<style  lang="scss">
    @import '../../../assets/style/shop/variables';
    @import '../../../assets/style/shop/header';

    .game-round,
    .game-countdown{
        color:#fff;
        font-weight: bold;
        font-size: 1em;
    }
</style>


// WEBPACK FOOTER //
// GameHeader.vue?6fa84b72